import { connect } from 'react-redux';

import ArchivedStatusActions from './component';

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(ArchivedStatusActions);
